<app-school-form
  [fromSettings]="true"
  [school]="school"
  [modalDisplayMode]="true"
  (changed)="save()"
></app-school-form>